import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { usePagePermission } from "@/hooks/usePagePermission";
import PageLoader from "@/components/PageLoader";
import useAuthUser from "@/hooks/useAuthUser";

const isOpenPath = (pathname) => {
    const currentPath = pathname.split("?")[0].replace(/\/+$/, "") || "/";
    return currentPath === "/modules";
};

const ProtectedPage = ({ children, fallback = "/dashboard" }) => {
    const { pathname } = useLocation();
    const userLoading = useSelector(
        (state) => state.rolePermissions.userLoading
    );
    const userLoaded = useSelector(
        (state) => state.rolePermissions.userLoaded
    );
    const sidebarLoading = useSelector(
        (state) => state.sidebarNavigation.loading
    );
    const sidebarLoaded = useSelector(
        (state) => state.sidebarNavigation.loaded
    );
    const authUser = useAuthUser();
    const { canView } = usePagePermission();

    if (authUser?.roleID === 1 || isOpenPath(pathname)) {
        return children;
    }

    if (userLoading || !userLoaded || sidebarLoading || !sidebarLoaded) {
        return <PageLoader />;
    }

    if (!canView) {
        return <Navigate to={fallback} replace />;
    }

    return children;
};

export default ProtectedPage;
